export const openPositions = [
    {
        id: 1,
        title: "Customer Service Support (US Clients)",
        type: "Night Shift",
        location: "US Timezone (Night Shift)",
        department: "Customer Success",
        description:
            "Provide exceptional customer service to US-based clients during night hours, handle inquiries, troubleshoot issues, and ensure customer satisfaction.",
        requirements: [
            "Excellent English communication",
            "Experience with US clients",
            "Customer service background",
            "Strong problem-solving skills",
            "Comfortable with night shift work",
        ],
    },
    {
        id: 2,
        title: "Backend Developer (.NET / Python / Java)",
        type: "Full-Time – Night Shift (EXP:0-1)",
        location: "Remote / Karimnagar Office (US Timezone)",
        department: "Engineering",
        description:
            "We’re looking for a passionate Backend Developer experienced in .NET, Python, or Java to build and optimize enterprise-grade backend systems.",
        responsibilities: [
            "Design & maintain scalable REST APIs and microservices.",
            "Collaborate with frontend and DevOps teams.",
        ],
        requirements: [
            ".NET Core / Python (Django/FastAPI) / Java (Spring Boot)",
            "SQL/NoSQL databases (PostgreSQL, MongoDB, MySQL)",
            "Experience with cloud platforms (AWS, Azure, GCP)",
        ],
        perks: [
            "Competitive salary & bonuses",
            "Remote or hybrid options",
            "Health insurance & PTO",
            "Learning & certification budget",
        ],
    },
    {
        id: 3,
        title: "Business Development Executive – IT Services (US Market)",
        type: "Full-Time",
        location: "Remote / Karimnagar Office",
        department: "Business Development",
        description:
            "Drive sales growth by generating leads, nurturing client relationships, and expanding our presence in the US market. A perfect role for ambitious professionals with strong communication and negotiation skills.",
        responsibilities: [
            "Generate leads and qualify prospects.",
            "Handle LinkedIn, email, and cold calling outreach.",
            "Coordinate meetings with US clients.",
            "Collaborate with marketing & sales teams.",
            "Maintain CRM and reporting dashboards.",
        ],
        requirements: [
            "Excellent communication skills.",
            "Experience in IT sales / BDE roles is a plus.",
            "Comfortable with night shift for US process.",
            "Strong negotiation skills.",
        ],
        perks: [
            "Attractive incentives.",
            "US client exposure.",
            "Career path to Business Development Manager.",
            "Flexible work environment.",
        ],
    },
    {
        id: 4,
        title: "UI/UX Designer – Product & Web Experience",
        type: "Full-Time",
        location: "Hybrid / Remote",
        department: "Design & UX",
        description:
            "Join our UX & Product Design team to craft intuitive, scalable, and visually engaging digital experiences. Work on dashboards, mobile UX, enterprise apps, and marketing sites.",
        responsibilities: [
            "Create wireframes, prototypes, and visual UI designs.",
            "Collaborate with engineering and product teams.",
            "Conduct user research and usability testing.",
            "Design mobile-first interfaces.",
        ],
        requirements: [
            "Strong portfolio of UX/UI design work.",
            "Experience with Figma or Adobe XD.",
            "Understanding of responsive design.",
            "Bonus: motion design, branding, illustration.",
        ],
        perks: [
            "Creative freedom & ownership.",
            "Work with global product teams.",
            "Flexible timings.",
            "Paid training for UX certifications.",
        ],
    },
    {
        id: 5,
        title: "Customer Success Specialist – US Client Support (Night Shift)",
        type: "Night Shift",
        location: "Remote / Karimnagar Office",
        department: "Customer Success",
        description:
            "You will work directly with our US-based enterprise clients to ensure successful onboarding, training, adoption, and long-term satisfaction. Ideal for people who are empathetic communicators and enjoy solving problems.",
        responsibilities: [
            "Support US clients via email, chat, and video calls.",
            "Perform product walkthroughs and onboarding.",
            "Troubleshoot user issues and provide timely resolutions.",
            "Coordinate internally with engineering and product teams.",
        ],
        requirements: [
            "Excellent English communication (written + verbal).",
            "Experience in customer support or client-facing roles.",
            "Ability to work US timezone night shift.",
            "Tech-savvy and fast learner.",
        ],
        perks: [
            "Night shift allowances.",
            "US client exposure & training.",
            "Remote or hybrid work flexibility.",
            "Career growth to Lead Customer Success Manager.",
        ],
    },
    {
        id: 6,
        title: "HR Executive",
        type: "Full-Time (Work From Office)",
        location: "Karimnagar – IT Towers, 4th Floor",
        department: "Human Resources",
        description:
            "We are looking for an experienced HR professional to independently handle end-to-end HR operations at our Karimnagar office, from recruitment to day-to-day coordination.",
        responsibilities: [
            "End-to-end recruitment (IT & Non-IT hiring)",
            "Screening resumes and coordinating interviews",
            "Employee onboarding & exit formalities",
            "Maintaining HR records, attendance & documentation",
            "Handling employee queries and coordination",
            "Implementing HR policies and compliance support",
            "Supporting payroll coordination & internal operations",
            "Office coordination and day-to-day HR activities",
        ],
        requirements: [
            "1–2 years of hands-on HR experience",
            "Ability to work independently",
            "Good communication & coordination skills",
            "Immediate or short-notice joiners preferred",
        ],
    },
];
